<template>
  <div :class="contextName">
    <AppHeader />
    <div class="content-all">
      <RouterView v-slot="{ Component, route }">
        <component :is="Component" v-bind="route.params" />
      </RouterView>
    </div>
    <AppFooter />
  </div>
</template>

<script setup>
import { useApp } from '@/base/composables/useApp'
import AppHeader from '@/base/components/Header/AppHeader'
import AppFooter from '@/base/components/Footer/AppFooter'

const { contextName } = useApp()
</script>

<style src="./assets/scss/main.scss" lang="scss"></style>
